export const SECTIONS_IDS = {
    CAMPAIGN_DIAGNOSTICS: 1,
    COPY_RATINGS: 2,
    UPLIFTS: 3,
    LINE_CHART: 4,
};
